export class LoginExternalModel {
    public provider: string;
    public providerKey: string;
    public authToken: string;
    public cartId: string;
}
